module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Murten-4dd831c82d113bf7a471ca2718cb2a85.svg";